// Э-15. Страница отслеживания для клиента (ФТ-9.5): без входа, по ссылке из заявки.
// Статус заказа, машины с госномером и временем прибытия, телефоны водителя и диспетчерской. Карта — Этап 4.

import { useEffect } from "react";
import { fmtDate, fmtNum, fmtTime, telHref } from "../../shared/format";
import { Loading, Plate, useAsync } from "../../shared/ui";
import { api } from "../ctx";

type TrackData = {
  number: number; date: string; site: string; address: string | null; grade: string; volume_m3: number; shipped_m3: number;
  status: string; dispatch_phone: string | null; updated_at: string;
  trips: { seq: number; status: string; volume_m3: number; plate: string | null; driver_phone: string | null; eta: string | null; arrived_at: string | null }[];
};

export function TrackPage({ token }: { token: string }) {
  const q = useAsync<TrackData>(() => api.raw<TrackData>("GET", `/public/track/${encodeURIComponent(token)}`, undefined, false), [token]);
  const reload = q.reload;
  useEffect(() => {
    document.title = "Отслеживание бетона";
    const t = setInterval(() => { if (document.visibilityState === "visible") reload(); }, 30_000);
    return () => clearInterval(t);
  }, [reload]);
  const d = q.data;
  return (
    <div className="track">
      <main className="track-body stack">
        {!d ? <Loading error={q.error} onRetry={reload} /> : (
          <>
            <div>
              <div className="small muted">Заказ бетона №{d.number} на {fmtDate(d.date)}</div>
              <h1 style={{ margin: "4px 0" }}>{d.status}</h1>
              <div>{d.site}{d.address ? `, ${d.address}` : ""}</div>
              <div className="muted">{d.grade} · отгружено <b className="num">{fmtNum(d.shipped_m3)}</b> из {fmtNum(d.volume_m3)} м³</div>
              <div className="bar" style={{ marginTop: 8 }}><i style={{ width: `${Math.min(100, (d.shipped_m3 / Math.max(d.volume_m3, 0.01)) * 100)}%` }} /></div>
            </div>
            <section className="driver-card">
              <h3 style={{ marginTop: 0 }}>Машины</h3>
              {d.trips.map((t) => (
                <div key={t.seq} className="track-trip">
                  <div className="num muted">{t.seq}</div>
                  <div>
                    <div><b>{t.status}</b>{t.eta && !t.arrived_at ? <> · прибытие <b className="num">~{fmtTime(t.eta)}</b></> : null}
                      {t.arrived_at ? <> · на объекте с {fmtTime(t.arrived_at)}</> : null}</div>
                    <div className="small muted">{fmtNum(t.volume_m3)} м³{t.plate ? <> · <Plate value={t.plate} small /></> : null}</div>
                  </div>
                  {t.driver_phone ? <a className="btn small" href={telHref(t.driver_phone)}>Водитель</a> : <span />}
                </div>
              ))}
            </section>
            {d.dispatch_phone && <a className="btn big" href={telHref(d.dispatch_phone)}>Диспетчерская: {d.dispatch_phone}</a>}
            <p className="small muted">Обновлено в {fmtTime(d.updated_at)}. Страница обновляется сама.</p>
          </>
        )}
      </main>
    </div>
  );
}
